<script>
import options from './RelayList.options'
export default options
</script>

<template>
  <!-- hide entire component if hideNoResults is set and there are no results  -->
  <template v-if="hideNoResults && !resultCount"></template>

  <article v-else class="kb-relay-list">
    <div class="kb-relay-list__header">
      <p class="kb-relay-list__header__count" aria-live="polite">
        {{ totalAmount }} {{ getLabel('resultCountTitle') }}
      </p>
    </div>

    <SearchFilteredTags v-if="tags.length > 0" :guids="[guid]" />

    <ul class="kb-relay-list__content" v-if="relays.length > 0">
      <template v-for="(relay, index) in relays" :key="index">
        <li class="kb-relay-list__content__item">
          <div
            v-if="relay.seasonStartDate && new Date(relay.seasonStartDate) <= new Date()"
            class="kb-relay-list__content__item__status"
            :class="isRelayActiveOrUpcoming(relay) ? 'kb-relay-list__content__item__status--open' : 'kb-relay-list__content__item__status--afholdt'"
          >
            {{ isRelayActiveOrUpcoming(relay) ? getLabel('labelAabenTilmelding') : getLabel('labelAfholdt') }}
          </div>
          <a :href="relay.url" class="kb-relay-list__content__item__link">
            <h2 class="kb-relay-list__content__item__link__title">
              {{ relay.name }}
            </h2>
            <div class="kb-relay-list__content__item__link__description">
              {{ getRelayDescription(relay) }}
            </div>
            <div class="kb-relay-list__content__item__link__arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 21 20"
                role="presentation"
              >
                <path
                  stroke="#E8001D"
                  stroke-linejoin="round"
                  d="m15.21 5 4.528 5-4.528 5"
                />
                <path stroke="#E8001D" d="M14.683 10H0" />
              </svg>
            </div>
          </a>
        </li>
      </template>
    </ul>

    <div class="kb-general-search__more-results" v-if="relays.length > 0">
      <span v-if="resultCount" class="kb-general-search__more-results__text">
        {{ getLabel('resultOutForTitle', [relays.length, totalAmount]) }}
      </span>
      <template v-if="relays.length < totalAmount">
        <button
          v-on:click="getMoreResults"
          class="kb-button kb-button--full-color"
        >
          {{ getLabel('ShowMoreButtonText') }}
        </button>
      </template>
    </div>

    <template v-if="!resultCount && !showSpinner && !hideNoResults">
      <div class="kb-general-search__no-results">
        <h2>{{ getLabel('noResultTitle') }}</h2>
        <p class="kb-general-search__no-results__summary">
          {{ getLabel('noResultDesc') }}
        </p>
        <a
          :href="getLabel('noResultButtonHref')"
          class="kb-button kb-button--full-color-spot"
          >{{ getLabel('noResultButtonText') }}</a
        >
      </div>
    </template>

    <div v-if="showSpinner" class="kb-spinner-overlay">
      <div class="kb-spinner-overlay__spinner"></div>
    </div>
  </article>
</template>
